import { cn } from '@/lib/utils';

interface LoaderProps {
	className?: string;
}

const Loader = ({ className }: LoaderProps) => {
	return (
		<div className="flex items-center justify-center">
			<div
				className={cn(
					'size-4 animate-spin rounded-full border-e-2  border-t-2 border-primary-dark ',
					className,
				)}
			></div>
		</div>
	);
};

export { Loader };
